import { useState } from "react";
import activities from "../../utils/activities.json";
import "./SettingActivity.css";

const SettingActivity = () => {
  const [getActivities, setGetActivities] = useState(activities);
  const removeTable = (id) => {
    setGetActivities((getActivities) =>
      getActivities.filter((activity) => activity.id !== id)
    );
  };
  return (
    <div className="settingActivity">
      <table>
        <tr>
          <th>Browser</th>
          <th>Device</th>
          <th>Location</th>
          <th>Last Accessed</th>
          <th></th>
        </tr>
        {getActivities.map((activity) => (
          <tr key={activity.id}>
            <td>{activity.browser}</td>
            <td>{activity.device}</td>
            <td>{activity.location}</td>
            <td>{activity.last_accessed}</td>
            <td>
              <button className="btn" onClick={() => removeTable(activity.id)}>
                Remove
              </button>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default SettingActivity;
